<ng-container *appI18nScopeReady>
  <h2 mat-dialog-title>{{ 'title' | i18n }}</h2>
  <mat-dialog-content>
    <mat-form-field appearance="outline">
      <mat-label id="add-view-name-label">{{ 'name_label' | i18n }}</mat-label>
      <input
        matInput
        id="add-view-name"
        aria-labelledby="add-view-name-label"
        [(ngModel)]="name"
        [placeholder]="'name_placeholder' | i18n"
        (keydown.enter)="apply()"
      />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-button (click)="cancel()">
      {{ 'cancel' | i18n }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      (click)="apply()"
      [disabled]="!name.trim()"
    >
      {{ 'create' | i18n }}
    </button>
  </mat-dialog-actions>
</ng-container>
